import { useEffect, useRef } from "react";

const useValueRef = val => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = val;
  }, [val]);

  return ref;
};

export default useValueRef;
